import { HttpClient } from '../../httpClient'
import type { OpalApi } from '../../schema'

export const readUser: OpalApi<'ReadUserV3', 200> = async ({
  params,
}: Parameters<OpalApi<'ReadUserV3', 200>>[0] = {}) =>
  HttpClient()
    .get(
      new URL(
        `/users/v3/users/${params?.path.user_id}`,
        window.location.origin
      ).toString()
    )
    .then((res) => res.data)
